const TINYMCE_API_KEY = 'aff340m13q81ya6431chv3t3tz9liuq4gxuaw6cjk9994qq3'

const API_URL = process.env.REACT_APP_API_HOST
const AUTH_URL = process.env.REACT_APP_AUTH_HOST

enum Permissions {
    CREATE_NEWS = 'crear-notas',
    UPDATE_NEWS = 'editar-notas',
    DELETE_NEWS = 'borrar-notas',
    CREATE_MAGAZINES = 'crear-edicion-impresa',
    UPDATE_MAGAZINES = 'editar-edicion-impresa',
    DELETE_MAGAZINES = 'borrar-edicion-impresa',
    CREATE_USERS = 'crear-usuarios',
    UPDATE_USERS = 'editar-usuarios',
    DELETE_USERS = 'borrar-usuarios',
    CREATE_PROFILES = 'crear-perfiles',
    UPDATE_PROFILES = 'editar-perfiles',
    DELETE_PROFILES = 'borrar-perfiles',
    CREATE_ADS = 'crear-publicidad',
    UPDATE_ADS = 'editar-publicidad',
    DELETE_ADS = 'borrar-publicidad'
}

export {
    TINYMCE_API_KEY,
    API_URL,
    AUTH_URL,
    Permissions
}